import * as angular from "angular";
import {IController} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";

export class DemandAccountLinkCtrl implements IController {
  account: AccountModel;
  address: any;
  phone: string;
  additionalPhone: string;
  isShowCopyButton: boolean;
  isShowFilterByButton: boolean;
  onFilterByType: Function;

  public isShowAccountActions: boolean;
  public siteFiltersType: typeof SiteFiltersType = SiteFiltersType;
}

angular
  .module('bringoz.admin.accounts')
  .component('demandAccountLink', {
    bindings: {
      account: '<',
      address: '<?',
      phone: '<?',
      additionalPhone: '<?',
      isShowCopyButton: '<?',
      isShowFilterByButton: '<?',
      onFilterByType: '&'
    },
    template: require('./demand-account-link.html').default,
    controller: DemandAccountLinkCtrl
  });
